import { useState } from "react";
import StepAuth from "./components/StepAuth";
import StepDocumentType from "./components/StepDocumentType";
import StepScanAndVerify from "./components/StepScanAndVerify";
import StepFaceVerify from "./components/StepFaceVerify";
import StepComplete from "./components/StepComplete";
import StepDashboard from "./components/StepDashboard";
import ProgressBar from "./components/ProgressBar";
import "./index.css";

const SIGNUP_STEPS = ["Account", "Document Type", "Scan & Verify", "Face Check", "Complete"];

export default function App({ initialRole, onComplete }) {
  const INITIAL_SESSION = {
    authMode: null,
    email: "",
    userId: "",
    idToken: "",
    accessToken: "",
    password: "",
    docType: null,
    idS3Key: "",
    extracted: null,
    profile: null,
    faceResult: null,
    faceLoginResult: null,
    role: initialRole || "creator",
  };

  const [step, setStep] = useState(0);
  const [session, setSession] = useState(INITIAL_SESSION);

  const updateSession = (patch) => setSession((s) => ({ ...s, ...patch }));

  const next = () => setStep((s) => Math.min(s + 1, SIGNUP_STEPS.length - 1));
  const back = () => setStep((s) => Math.max(s - 1, 0));

  const handleSignOut = () => {
    setSession(INITIAL_SESSION);
    setStep(0);
  };

  const handleComplete = () => {
    if (onComplete) onComplete(session);
  };

  // Sign In complete → show dashboard
  if (session.authMode === "signin" && step > 0) {
    return (
      <div className="app-shell">
        <header className="app-header">
          <span className="logo">Identity Verify</span>
          <span className="step-label">Dashboard</span>
        </header>
        <main className="step-container">
          <StepDashboard session={session} onSignOut={handleSignOut} />
        </main>
      </div>
    );
  }

  // Sign Up / registration flow
  return (
    <div className="app-shell">
      <header className="app-header">
        <span className="logo">Identity Verify</span>
        <span className="step-label">{SIGNUP_STEPS[step]}</span>
      </header>

      {session.authMode === "signup" && (
        <ProgressBar current={step} total={SIGNUP_STEPS.length} labels={SIGNUP_STEPS} />
      )}

      <main className="step-container">
        {step === 0 && (
          <StepAuth session={session} updateSession={updateSession} onNext={next} />
        )}
        {step === 1 && (
          <StepDocumentType session={session} updateSession={updateSession} onNext={next} onBack={back} />
        )}
        {step === 2 && (
          <StepScanAndVerify session={session} updateSession={updateSession} onNext={next} onBack={back} />
        )}
        {step === 3 && (
          <StepFaceVerify session={session} updateSession={updateSession} onNext={next} onBack={back} />
        )}
        {step === 4 && (
          <StepComplete session={session} onComplete={handleComplete} />
        )}
      </main>
    </div>
  );
}
